import { Link } from "react-router-dom";

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden relative border-2 border-gray-100">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              alt="アイルランド留学相談"
              className="w-full h-full object-cover object-center"
              src="https://public.readdy.ai/ai/img_res/edited_d7667d8ba4df0d65fc0ab1d6aee7e8fc_fa42cf94.jpg"
            />
            <div className="absolute inset-0 bg-black/50" />
          </div>

          <div className="p-6 md:p-16 relative z-10">
            {/* Heading */}
            <div className="text-center mb-8 md:mb-12">
              <h2 className="text-xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
                私たちと一緒に、<br />留学の夢を叶えましょう！
              </h2>
              <p className="text-base md:text-xl text-white/95 font-medium mb-2">
                お問い合わせ、ご相談はLINEから！
              </p>
              <p className="text-xs md:text-sm text-white/80">
                留学前も、留学中もLINE1つで気軽に話しかけていただけます！
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center">
              {/* QR Code */}
              <div className="flex justify-center">
                <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-8 inline-block shadow-xl border-2 border-gray-100">
                  <img
                    alt="LINE QR Code"
                    className="w-36 h-36 md:w-56 md:h-56 mx-auto mb-4 md:mb-6 object-contain"
                    src="https://static.readdy.ai/image/7e5541a56ec34f9c335c4f691557a0ff/e1baf93312b155fc04e26b58aedc7f5f.png"
                  />
                  <div className="text-center">
                    <img
                      alt="LINE Logo"
                      className="h-8 md:h-10 w-auto mx-auto"
                      src="https://cdn.prod.website-files.com/67f378cb597b81cc842aaf26/680e2e5d5d44931472ea7a55_LINE_LOGO.svg"
                    />
                  </div>
                </div>
              </div>

              {/* Right: features + buttons */}
              <div className="space-y-6">
                {[
                  { title: "無料個別相談も受付中！", sub: "経験豊富なカウンセラーが丁寧にサポート" },
                  { title: "学校資料のダウンロードも可能！", sub: "詳しい情報をすぐにお届けします" },
                  { title: "お申し込みもLINEから簡単！", sub: "手続きもスムーズにサポートします" },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4 text-white">
                    <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-2xl" />
                    </div>
                    <div>
                      <p className="text-base font-bold mb-1">{item.title}</p>
                      <p className="text-sm text-white/80">{item.sub}</p>
                    </div>
                  </div>
                ))}

                <div className="pt-4 space-y-3">
                  {/* LINE button */}
                  <div className="text-center mb-1">
                    <p className="text-sm font-bold text-[#06C755]">
                      <i className="ri-gift-line text-base mr-1" />
                      \今なら特典もプレゼント!/
                    </p>
                  </div>
                  <a
                    href="https://lstep.app/N5D3BZr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-3 bg-[#06C755] text-white px-10 py-4 rounded-full font-bold text-base hover:bg-[#05b34c] transition-colors shadow-lg cursor-pointer whitespace-nowrap w-full"
                  >
                    <i className="ri-line-line text-2xl" />
                    LINE友だち追加
                  </a>

                  {/* Counseling button */}
                  <div className="text-center mb-1">
                    <p className="text-sm font-bold text-emerald-300">
                      <i className="ri-time-line text-base mr-1" />
                      \簡単30秒!/
                    </p>
                  </div>
                  <Link
                    to="/counseling"
                    className="inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-10 py-4 rounded-full font-bold text-base transition-colors shadow-lg cursor-pointer whitespace-nowrap w-full"
                  >
                    <i className="ri-calendar-check-line text-2xl" />
                    無料カウンセリング予約
                  </Link>

                  <p className="text-center text-white/70 text-xs pt-1">
                    ※電話番号: 0120-963-815
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}